import { Injectable, Injector } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FeatureAggregationService, FeatureProvidersServiceInterface } from '@y42/feature';
import {
  OrchestrationNodeLogsDialogComponent,
  OrchestrationNodeLogsDialogData,
} from './orchestration-node-logs-dialog.component';

@Injectable()
export class OrchestrationNodeLogsDialogService {
  constructor(
    private readonly dialog: MatDialog,
    private readonly featureAggregationService: FeatureAggregationService,
    private readonly featureProvidersService: FeatureProvidersServiceInterface,
    private readonly injector: Injector,
  ) {}

  showDialog(data: OrchestrationNodeLogsDialogData) {
    const featureType = this.featureAggregationService.getServiceDefinitionByPath(data.path)?.featureType;
    if (!featureType) {
      return;
    }
    this.dialog.open<OrchestrationNodeLogsDialogComponent, OrchestrationNodeLogsDialogData>(
      OrchestrationNodeLogsDialogComponent,
      {
        width: '80vw',
        height: '80vh',
        panelClass: ['full-screen-popup'],
        data,
        injector: Injector.create({
          parent: this.injector,
          providers: [this.featureProvidersService.prepareProviders(featureType)],
        }),
      },
    );
  }
}
